import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SezioneTitoli } from '../../../models/sezioni/sezione-titoli';
import { TitoloEsecutivo } from '../../../models/titolo-esecutivo';
import { TitoloUpdateConcreteFormComponent } from './titolo-update-concrete-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [modale_modifica_titolo]',
  templateUrl: 'titolo-modal-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class TitoloMoldaUpdateComponent {
  @Output() onReturn: EventEmitter<SezioneTitoli> = new EventEmitter<SezioneTitoli>();
  @ViewChild('formTitolo') formTitolo: TitoloUpdateConcreteFormComponent;

  inizializza(urlUpdate: string, titolo: TitoloEsecutivo, idSezione: string) {
    this.formTitolo.inizializza(urlUpdate, titolo, idSezione);
    openModal('modaleUpdateTitolo');
  }

  createForm() {
    this.formTitolo.createForm();
  }

  manageModal(sezione: SezioneTitoli) {
    if (sezione) {
      closeModal('modaleUpdateTitolo');
      this.onReturn.emit(sezione);
    }
  }
}
